import { render, staticRenderFns } from "./ScoutingScoreSummaryV3.vue?vue&type=template&id=3c613a11&scoped=true&"
import script from "./ScoutingScoreSummaryV3.vue?vue&type=script&lang=ts&"
export * from "./ScoutingScoreSummaryV3.vue?vue&type=script&lang=ts&"
import style0 from "./ScoutingScoreSummaryV3.vue?vue&type=style&index=0&id=3c613a11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c613a11",
  null
  
)

export default component.exports